import Vue from 'vue'
import { Dialog } from 'vant'
import { Language } from "@/language/index.js";
import router from '@/router'

Vue.use(Dialog)
let dialog = Dialog // 弹框
// 显示弹框
export const showDialog = params => {
  const { title, msg } = params
  dialog
    .alert({
      title: title,
      message: msg,
      confirmButtonText: Language.alert.confirmButtonText,
      className: 'showDialogClass'
    })
    .then(() => {
      dialog.close()
    })
}
export const hideDialog = () => {
  dialog.close()
}

export default {
  showDialog,
  hideDialog,
}
